import { useEffect } from "react";
import { useRouter } from "next/router";
import { loadCatalog } from "../../i18n";

export async function getStaticProps({ ...ctx }) {
  const translation = await loadCatalog(ctx.locale);
  return { props: { translation } };
}

export default function MabarIndex() {
  const router = useRouter();
  useEffect(() => {
    router.replace("/mabar/queue");
  }, []);
  return null;
}
